(() => {
  const pageSelector = '[data-pdp-size-guide-page]';

  const initializeSizeTables = (page) => {
    for (const button of page.querySelectorAll('.size-guide-wrapper .size-toggle-buttons button')) {
      if (button.dataset.themeSizeGuideBound === 'true') continue;
      button.dataset.themeSizeGuideBound = 'true';

      button.addEventListener('click', () => {
        const wrapper = button.closest('.size-guide-wrapper');
        const target = button.dataset.target;
        if (!wrapper || !target) return;

        for (const candidate of wrapper.querySelectorAll('.size-toggle-buttons button')) {
          candidate.classList.toggle('active', candidate === button);
        }
        for (const table of wrapper.querySelectorAll('.size-table')) {
          table.classList.toggle('active', table.dataset.table === target);
        }
      });
    }
  };

  const initializeTrueFit = (page) => {
    const helper = page.querySelector('#truefit-helper');
    const button = page.querySelector('#truefit-button');
    const trueFitElement = document.querySelector('.tfc-fitrec-product');
    if (!(helper instanceof HTMLElement) || !(button instanceof HTMLButtonElement) || !trueFitElement) return;

    helper.style.display = 'block';
    if (button.dataset.themeTrueFitBound === 'true') return;
    button.dataset.themeTrueFitBound = 'true';

    button.addEventListener('click', () => {
      const styleId = trueFitElement.dataset.styleid;
      if (!styleId || typeof window.tfcapi !== 'function') return;
      window.tfcapi('triggerOpen', { styleId });
    });
  };

  const initialize = () => {
    for (const page of document.querySelectorAll(pageSelector)) {
      initializeSizeTables(page);
      initializeTrueFit(page);
    }
  };

  initialize();
  window.addEventListener('load', initialize, { once: true });
})();
